import AuthApi from './AuthApi';
import UserApi from './UserApi';
import TreeApi from './TreeApi';
import ReportsApi from './ReportsApi';
import FinanceApi from './FinanceApi';
import BetHistoryApi from './SportHistoryApi';
import AgentAdminApi from './AgentAdminApi';
import StatisticApi from './StatisticApi';
import BonusProgramApi from './BonusProgramApi';
import CbuPaymentsApi from './CbuPaymentsApi';
import CashbackApi from './CashbackApi';
import AssistantApi from './AssistantApi';
import SurveyApi from './SurveyApi';

import CreativeFunctionalityApi from './CreativeFunctionalityApi';
import { CasinoApi } from 'modules/Casino/api';

class Api {
  constructor(baseUrl = '') {
    this.auth = new AuthApi(baseUrl);
    this.user = new UserApi(baseUrl);
    this.tree = new TreeApi(baseUrl);
    this.reports = new ReportsApi(baseUrl);
    this.statistic = new StatisticApi(baseUrl);
    this.finance = new FinanceApi(baseUrl);
    this.sportHistory = new BetHistoryApi(baseUrl);
    this.agentAdmin = new AgentAdminApi(baseUrl);
    this.bonusProgram = new BonusProgramApi(baseUrl);
    this.cbuPayment = new CbuPaymentsApi(baseUrl);
    this.cashback = new CashbackApi(baseUrl);
    this.creativeFunctionality = new CreativeFunctionalityApi(baseUrl);
    this.casino = new CasinoApi(baseUrl);
    this.assistant = new AssistantApi(baseUrl);
    this.survey = new SurveyApi(baseUrl);
  }
}

export default Api;
